// Polyfill URL.parse for iOS Safari < 17 / older browsers. pdfjs-dist uses
// URL.parse() at module init; without this, the app crashes on load.
if (typeof URL.parse !== 'function') {
  URL.parse = function (url, base) {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}

// Sync the iOS Safari status-bar tint with whichever theme the user picked.
// Called at boot and whenever the theme changes (see AppShell/ClientShell).
(function syncThemeColor() {
  const apply = () => {
    const theme = document.documentElement.getAttribute('data-theme')
      || localStorage.getItem('pi-portal-theme')
      || 'light';
    const color = theme === 'dark' ? '#14171f' : '#ffffff';
    let tag = document.querySelector('meta[name="theme-color"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'theme-color');
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', color);
  };
  // Initial theme is read from localStorage before React mounts
  const saved = localStorage.getItem('pi-portal-theme') || 'light';
  document.documentElement.setAttribute('data-theme', saved);
  apply();
  // Watch for further theme changes triggered by the shell's toggle
  new MutationObserver(apply).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-theme'],
  });
})();

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
